var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route } from "react-router-dom";
import TemplateEditor from "../TemplateEditor";
import TemplateForm from "./scenes/TemplateForm";
import TemplatesOverview from "./scenes/TemplatesOverview";
export var getTemplatesScene = function (params) { return (_jsxs(Route, __assign({ path: "templates" }, { children: [_jsx(Route, { index: true, element: _jsx(TemplatesOverview, { internal: params.internal }) }), _jsx(Route, { path: "form", element: _jsx(TemplateForm, {}) }), _jsx(Route, { path: "form/:templateId", element: _jsx(TemplateForm, {}) }), _jsx(Route, { path: "edit-data/:templateId", element: _jsx(TemplateEditor, {}) })] }))); };
